import React from "react";
import { Transfer } from "antd";

function TransferItem(props) {
  return (
    <Transfer
      showSearch
      oneWay={false}
      listStyle={{ width: 280, height: 340 }}
      {...props}
    />
  );
}

export default TransferItem;
